import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { BitsyModal } from '..';

const Variations = ({
  productInfo,
  color = 'NONE',
  selectedVariation,
  toggleVariation,
}) => {
  const [modalType, setModalType] = useState('NONE');
  const dictionary = JSON.parse(productInfo.quantityDictionaryAsString);
  const { variations, colors } = dictionary;
  let availableVariations = variations.slice(0, variations.length);
  if (color !== 'NONE') {
    availableVariations = [];
    Object.keys(dictionary[colors]).forEach((item) => {
      if (dictionary[colors][item] > 0) availableVariations.push(item);
    });
  }

  const renderModal = () => {
    if (modalType === 'SIZE CHART') {
      return (
        <BitsyModal
          isShowingModal
          content='viewSizeChart'
          onExit={() => setModalType('NONE')}
          type='bodyWithDataAndExitModal'
          data={{
            additionalBody: (
              <Row>
                <Col className='sizeChartCol'>
                  {variations.map((variation) => (
                    <p key={variation}>{variation}</p>
                  ))}
                </Col>
              </Row>
            ),
          }}
        />
      );
    }
    return null;
  };

  const viewSizeChart = () => {
    setModalType('SIZE CHART');
  };

  const onKeyDownSizeChart = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      setModalType('SIZE CHART');
    }
  };

  const renderVariationButtons = () => {
    return variations.map((variation) => {
      const isAvailable = availableVariations.indexOf(variation) >= 0;
      let shortenedSizeName;
      if (productInfo.variationName === 'Size' && variation.includes('(')) {
        shortenedSizeName = variation.split('(')[0].trim();
      }

      if (
        (isAvailable && dictionary[variation].overallQuantity) ||
        productInfo.isDropShip ||
        productInfo.isComposite
      ) {
        return (
          <Button
            key={`variation-item-${variation}`}
            onClick={() => toggleVariation(variation, productInfo.media)}
            className={
              variation === selectedVariation ? 'selected' : 'unselected'
            }
            variant='info'
          >
            {shortenedSizeName || variation}
          </Button>
        );
      }

      return (
        <Button
          key={`variation-item-${variation}`}
          className='outOfStockVariation'
          variant='info'
          disabled
        >
          {shortenedSizeName || variation}
        </Button>
      );
    });
  };

  return (
    <>
      {renderModal()}
      <Row>
        <Col className='variationTitleCol'>
          <p>Select {productInfo.variationName}:</p>
          <Button
            variant='link'
            className='sizeChartButton'
            onClick={viewSizeChart}
            onKeyDown={onKeyDownSizeChart}
          >
            Size Chart
          </Button>
        </Col>
      </Row>
      <Row>
        <Col className='variationSelectCol'>{renderVariationButtons()}</Col>
      </Row>
    </>
  );
};

export default Variations;
